import { useState, useCallback, useEffect } from "react";
import { Avatar, Icon, TopBar } from "@shopify/polaris";
import "@shopify/polaris/build/esm/styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "./Axios";
import {
  HomeIcon,
  ProductIcon,
  CartIcon,
  CheckIcon,
  CashDollarIcon,
  ProductFilledIcon,
  IdentityCardFilledIcon,
  ProfileIcon,
  SettingsIcon,
  QuestionCircleIcon
} from "@shopify/polaris-icons";
function Header() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [localData, setLocalData] = useState();
  const [shop_url, setshopurl] = useState(null);
  const domain = process.env.REACT_APP_BASE_URL;
  const location = useLocation(); // Get the current route

  const navigate = useNavigate()
  const toggleIsUserMenuOpen = useCallback(() => {
    setIsUserMenuOpen((open) => !open)
  }, []
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        const tempcode = localStorage.getItem("tempcode")
        const shopurl = localStorage.getItem("shopurl")
        setshopurl(localStorage.getItem("shopurl"))
        let url;
        if (!shopurl) {
          if (tempcode) {
            url = `${process.env.REACT_APP_API_URL}/getuserdetail?key=${tempcode}`;
               const response = await axios.get(url);

          if (response.status !== 200 || !response.data.success) {
            console.error("Failed to fetch user data:", response);
            return;
          }

          // console.log("Header ->>", response.data.success.shopurl);
          setLocalData(response.data.success.shopurl);
          localStorage.setItem("shopurl", response.data.success.shopurl)
          } 
          // Need to remove these conditions for hardcoded tempcode 
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);

  const handleLogOut = () => {
    localStorage.removeItem("storeData");
    localStorage.removeItem("tempcode");
    localStorage.removeItem("validationValue");
    localStorage.removeItem("plans");
    navigate(`${process.env.REACT_APP_BASE_URL}/login`)
  }
const userName = shop_url || localData || '';
const userInitials = (shop_url || localData || '')[0]?.toUpperCase() || '';

const userMenuMarkup = (
    <TopBar.UserMenu
      actions={[
        {
          items: [
              {
              icon: HomeIcon,
              content: 'Dashboard',
              active:location.pathname === `${domain}/`,
              onAction: () => navigate(`${domain}/`),
             suffix:  location.pathname === `${domain}/` ?<Icon source={CheckIcon} /> : null , // Checkmark

            }, 
             {
              icon: ProductIcon,
              content: 'Ebay Products',
              active:location.pathname === `${domain}/products`,
              onAction: () => navigate(`${domain}/products`),
              suffix:  location.pathname === `${domain}/products` ?<Icon source={CheckIcon} /> : null , // Checkmark

            }, 
             {
              content: 'Shopify Products',
              open:true,
              icon: ProductFilledIcon,
              active:location.pathname === `${domain}/shopify_products`,
              suffix:  location.pathname === `${domain}/shopify_products` ?<Icon source={CheckIcon} /> : null , // Checkmark

              onAction: () => navigate(`${domain}/shopify_products`),
            },
             {
              content: 'Ebay Account',
              active:location.pathname === `${domain}/ebayaccounts`,
             icon: IdentityCardFilledIcon,
             suffix:  location.pathname === `${domain}/ebayaccounts` ?<Icon source={CheckIcon} /> : null , // Checkmark

              onAction: () => navigate(`${domain}/ebayaccounts`),
            },
             {
              content: 'Profile',
              icon: ProfileIcon,
              suffix:  location.pathname === `${domain}/profile` ?<Icon source={CheckIcon} /> : null , // Checkmark
              active:location.pathname === `${domain}/profile`,
              onAction: () => navigate(`${domain}/profile`),
            },
             {
              content: 'Settings',
              // prefix:SettingsIcon,
              icon: SettingsIcon,
              suffix:  location.pathname === `${domain}/settings` ?<Icon source={CheckIcon} /> : null , // Checkmark
              active: location.pathname.startsWith(`${domain}/settings`),
              onAction: () => navigate(`${domain}/settings`),
            },
            {
              content: 'Logout',
              onAction: () => handleLogOut(),
            },
          ],
        },
      ]}
      name={userName}
      initials={userInitials}
      open={isUserMenuOpen}
      onToggle={toggleIsUserMenuOpen}
    />

);

  // Top Bar
  const topBarMarkup = <TopBar userMenu={userMenuMarkup} />;

  return <div>{topBarMarkup}</div>;
}

export default Header;
